import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Link,
  Typography,
  Divider,
  IconButton,
  Stack
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import logo from '../../assets/images/infhire_logo.webp';
import logoSm from '../../assets/images/infhire_logo_sm.webp';

const Footer = () => {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        pt: 6,
        pb: 3,
        mt: 'auto',
        borderTop: '1px solid #eaeaea'
      }}
      component="footer"
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ mb: 2 }}>
              <RouterLink to="/">
                <img src={logo} srcSet={`${logoSm} 160w, ${logo} 300w`} sizes="105px" alt="InfHire Logo" width={105} height={72} loading="lazy" style={{ height: '72px' }} />
              </RouterLink>
            </Box>
            <Typography variant="body2" color="text.secondary" paragraph>
              Connect & Collab - The platform that brings brands and influencers together for impactful collaborations.
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton aria-label="facebook" size="small">
                <FacebookIcon fontSize="small" />
              </IconButton>
              <IconButton aria-label="twitter" size="small">
                <TwitterIcon fontSize="small" />
              </IconButton>
              <IconButton aria-label="instagram" size="small">
                <InstagramIcon fontSize="small" />
              </IconButton>
              <IconButton aria-label="linkedin" size="small">
                <LinkedInIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" component="h2" color="text.primary" gutterBottom>
              Platform
            </Typography>
            <Link component={RouterLink} to="/how-it-works" color="inherit" display="block" sx={{ mb: 1 }}>
              How It Works
            </Link>
            <Link component={RouterLink} to="/help" color="inherit" display="block" sx={{ mb: 1 }}>
              Help Center
            </Link>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" component="h2" color="text.primary" gutterBottom>
              Company
            </Typography>
            <Link component={RouterLink} to="/about" color="inherit" display="block" sx={{ mb: 1 }}>
              About Us
            </Link>
            <Link component={RouterLink} to="/careers" color="inherit" display="block" sx={{ mb: 1 }}>
              Careers
            </Link>
            <Link component={RouterLink} to="/press" color="inherit" display="block" sx={{ mb: 1 }}>
              Press
            </Link>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" component="h2" color="text.primary" gutterBottom>
              Legal
            </Typography>
            <Link component={RouterLink} to="/terms" color="inherit" display="block" sx={{ mb: 1 }}>
              Terms and Conditions
            </Link>
            <Link component={RouterLink} to="/privacy" color="inherit" display="block" sx={{ mb: 1 }}>
              Privacy Policy
            </Link>
            <Link component={RouterLink} to="/refund-policy" color="inherit" display="block" sx={{ mb: 1 }}>
              Refund Policy
            </Link>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 3 }} />
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} InfHire. All rights reserved.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Connect & Collab
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
